module.exports = "https://cdn-shared.mathletics.com/teacher-modules/school-usage-reports/90/assets/images/5c94e107935f642337ffa5c7307ee4c7.svg";


//////////////////
// WEBPACK FOOTER
// ./assets/badges/Silver/Silver0.svg
// module id = hHdG
// module chunks = 1